import type { ComponentPropsWithoutRef } from "react";

export const IconBadge = ({
  children,
  className,
  ...props
}: React.PropsWithChildren<ComponentPropsWithoutRef<"div">>) => {
  const classes = className
    ? `text-dsa-red inline-flex size-14 items-center justify-center rounded-lg bg-rose-50 ${className}`
    : "text-dsa-red inline-flex size-14 items-center justify-center rounded-lg bg-rose-50";

  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
};

export default IconBadge;
